module.exports = __webpack_public_path__ + "img/arrow-right-filled-white.2dd63e45.svg";